import {
  FeaturesContent as baseFeaturesText,
  getLocalizedContent,
} from "@onzeit/shared";
import { useLocation, useParams } from "@remix-run/react";
import { FeaturesList } from "~/components";

export default function Index() {
  const { locale } = useParams();
  const pathName = useLocation().pathname;
  const content = getLocalizedContent(locale!, baseFeaturesText);
  return (
    <FeaturesList
      {...content}
      locale={locale!}
      content=""
      pathName={pathName}
    />
  );
}
